export default __webpack_public_path__ + "static/media/1321.c752c420.png";